module.exports = require("lit-element");